(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaiko-giftcard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT = '.aaiko-giftcard';
    const EMAIL_PROP = 'properties[Recipient email]';
    const MESSAGE_PROP = 'properties[Message]';

    /** Mirror the checked denomination onto the hidden cart id input. */
    function syncVariant(root) {
      const checked = root.querySelector('.aaiko-giftcard__amount-input:checked');
      const idInput = root.querySelector('input[name="id"]');
      if (checked && idInput) idInput.value = checked.value;
    }

    /**
     * Shopify only accepts the gift card recipient properties when a recipient
     * is actually set. Nameless controls are never submitted, so the names go
     * on only once the buyer has typed an address.
     */
    function syncRecipient(root) {
      const email = root.querySelector('[data-gc-email]');
      const message = root.querySelector('[data-gc-message]');
      const flag = root.querySelector('[data-gc-flag]');
      const offset = root.querySelector('[data-gc-offset]');
      if (!email) return;

      const on = email.value.trim().length > 0;
      email.name = on ? EMAIL_PROP : '';
      if (message) message.name = on && message.value.trim().length > 0 ? MESSAGE_PROP : '';
      if (flag) flag.disabled = !on;
      if (offset) {
        offset.disabled = !on;
        offset.value = String(new Date().getTimezoneOffset());
      }
    }

    function sync(root) {
      syncVariant(root);
      syncRecipient(root);
    }

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const root = target.closest(ROOT);
      if (root) sync(root);
    });

    document.addEventListener('input', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.matches('[data-gc-email], [data-gc-message]')) return;
      const root = target.closest(ROOT);
      if (root) syncRecipient(root);
    });

    const boot = () => document.querySelectorAll(ROOT).forEach(sync);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaiko-product-recs"] && !Shopify.designMode) return;
  try {
    
class AaikoProductRecs extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-recs-list]');
    this.prev = this.querySelector('.aaiko-recs__arrow--prev');
    this.next = this.querySelector('.aaiko-recs__arrow--next');
    if (!this.list) return;

    if (this.prev && this.next) {
      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }
    this.syncArrows();

    if (this.dataset.state === 'ready' || this.dataset.state === 'empty') return;

    // Both sources cost a request, and neither row is ever above the fold on a
    // product page. Fetch when the row is within a screen of the viewport.
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '400px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  load() {
    const done = (cells) => {
      if (!cells || !cells.length) {
        this.dataset.state = 'empty';
        return;
      }
      this.list.replaceChildren(...cells);
      this.dataset.state = 'ready';
      this.syncArrows();
    };
    const fail = () => {
      this.dataset.state = 'empty';
    };

    if (this.dataset.source === 'recently_viewed') {
      this.loadRecent().then(done).catch(fail);
    } else {
      this.loadRecommendations().then(done).catch(fail);
    }
  }

  /** @param {string} html @returns {Element[]} */
  cellsFrom(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('.aaiko-recs__cell:not(.aaiko-recs__cell--skeleton)'));
  }

  loadRecommendations() {
    return fetch(this.dataset.url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => this.cellsFrom(html));
  }

  loadRecent() {
    // Horizon's list, written by snippets/scripts.liquid on every product page.
    let stored = [];
    try {
      const raw = window.localStorage.getItem('viewedProducts');
      stored = raw ? JSON.parse(raw) : [];
    } catch (e) {
      stored = [];
    }
    if (!Array.isArray(stored)) stored = [];

    const exclude = String(this.dataset.exclude);
    const ids = stored
      .map(String)
      .filter((id) => id !== exclude)
      .slice(0, Number(this.dataset.limit) || 8);
    if (!ids.length) return Promise.resolve([]);

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${this.dataset.searchUrl}?section_id=aaiko-recent-list&type=product&q=${encodeURIComponent(query)}`;

    return fetch(url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => {
        // Search answers in relevance order. The row is called Recently viewed,
        // so it is put back in the order the list was written.
        const byId = new Map(
          this.cellsFrom(html).map((cell) => [String(cell.dataset.productId), cell])
        );
        return ids.map((id) => byId.get(id)).filter(Boolean);
      });
  }

  scrollByCard(direction) {
    const cell = this.list.firstElementChild;
    const step = cell ? cell.getBoundingClientRect().width + 4 : this.list.clientWidth / 4;
    this.list.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  /* Whether the pair exists at all: four or fewer cards fill the desktop row
     exactly, so there is nothing for an arrow to scroll to. Counted here and
     not in updateArrows(), which is also the scroll handler. */
  syncArrows() {
    const cells = this.list.querySelectorAll(
      '.aaiko-recs__cell:not(.aaiko-recs__cell--skeleton)'
    ).length;
    this.dataset.arrows = cells > 4 ? 'true' : 'false';
    this.updateArrows();
  }

  /* Whether each arrow can act right now. */
  updateArrows() {
    if (!this.prev || !this.next) return;
    const max = this.list.scrollWidth - this.list.clientWidth - 1;
    this.prev.disabled = this.list.scrollLeft <= 0;
    this.next.disabled = this.list.scrollLeft >= max;
  }
}
if (!customElements.get('aaiko-product-recs')) {
  customElements.define('aaiko-product-recs', AaikoProductRecs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaiko-product-row"] && !Shopify.designMode) return;
  try {
    
class AaikoProductRow extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.aaiko-row__list');
    this.prev = this.querySelector('.aaiko-row__arrow--prev');
    this.next = this.querySelector('.aaiko-row__arrow--next');
    if (!this.list || !this.prev) return;
    this.prev.addEventListener('click', () => this.scrollByCard(-1));
    this.next.addEventListener('click', () => this.scrollByCard(1));
    this.list.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update(), { passive: true });
    this.update();
  }
  scrollByCard(dir) {
    const card = this.list.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + 4 : this.list.clientWidth / 4;
    this.list.scrollBy({ left: dir * step, behavior: 'smooth' });
  }
  update() {
    const max = this.list.scrollWidth - this.list.clientWidth - 1;
    this.prev.disabled = this.list.scrollLeft <= 0;
    this.next.disabled = this.list.scrollLeft >= max;
  }
}
if (!customElements.get('aaiko-product-row')) {
  customElements.define('aaiko-product-row', AaikoProductRow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aaiko-search-panel"] && !Shopify.designMode) return;
  try {
    
class AaikoSearchPanel extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-aaiko-search-dialog]');
    this.input = this.querySelector('[data-aaiko-search-input]');
    this.results = this.querySelector('[data-aaiko-search-results]');
    this.opener = null;
    this.controller = null;
    this.hideTimer = null;
    this.defaultResults = this.results ? this.results.outerHTML : '';
    // read --aaiko-dur from the shared motion layer rather than restating it;
    // reduced motion collapses it to ~1ms and the panel then hides at once
    const dur = getComputedStyle(document.documentElement).getPropertyValue('--aaiko-dur').trim();
    this.fadeMs = parseFloat(dur) || 280;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.fadeMs = 1;

    this.onDocumentClick = (event) => {
      const opener = event.target.closest('[data-aaiko-search-open]');
      if (opener) {
        event.preventDefault();
        this.open(opener);
        return;
      }
      // Progressive enhancement: a plain link to the search page (the header
      // search button) opens the panel instead of navigating. Links that
      // already carry a query keep working as links.
      const link = event.target.closest('a[href]');
      if (!link || this.contains(link)) return;
      const url = new URL(link.href, window.location.origin);
      if (url.pathname.replace(/\/$/, '').endsWith('/search') && !url.searchParams.get('q')) {
        event.preventDefault();
        this.open(link);
      }
    };
    document.addEventListener('click', this.onDocumentClick);

    this.querySelectorAll('[data-aaiko-search-close]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.close();
      }
      if (event.key === 'Tab') this.trapFocus(event);
    });

    if (this.input) {
      let timer = null;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.search(this.input.value.trim()), 200);
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  /* Visual state, NOT the `hidden` attribute: during the fade-out the panel is
     still un-hidden while data-state is already gone. Same contract as the nav
     drawer, because `display: none` cannot be transitioned. */
  get isOpen() {
    return this.hasAttribute('data-state');
  }

  open(opener) {
    if (this.isOpen) return;
    clearTimeout(this.hideTimer);
    this.opener = opener || null;
    this.hidden = false;
    // two frames: the first commits the un-hidden layout, the second starts
    // the transition from it
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.setAttribute('data-state', 'open'));
    });
    // Horizon scrolls inside .page-wrapper, so locking body alone is not enough
    this.scrollLock = [document.body, document.querySelector('.page-wrapper')].filter(Boolean);
    this.scrollLock.forEach((el) => {
      el.dataset.aaikoSearchOverflow = el.style.overflow;
      el.style.overflow = 'hidden';
    });
    if (this.input) {
      this.input.focus();
      this.input.setSelectionRange(this.input.value.length, this.input.value.length);
    }
  }

  close() {
    if (!this.isOpen) return;
    this.removeAttribute('data-state');
    // `hidden` only after the fade, or the panel disappears instantly
    this.hideTimer = setTimeout(() => this.setAttribute('hidden', ''), this.fadeMs);
    (this.scrollLock || []).forEach((el) => {
      el.style.overflow = el.dataset.aaikoSearchOverflow || '';
      delete el.dataset.aaikoSearchOverflow;
    });
    if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
  }

  get focusable() {
    return Array.from(
      this.dialog.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
    ).filter((el) => el.offsetParent !== null);
  }

  trapFocus(event) {
    const items = this.focusable;
    if (items.length === 0) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async search(term) {
    if (!this.results) return;
    if (!term) {
      this.classList.remove('aaiko-search-panel--querying');
      this.replaceResults(this.defaultResults);
      return;
    }
    this.classList.add('aaiko-search-panel--querying');
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    const url = new URL(this.dataset.suggestUrl || '/search/suggest', window.location.origin);
    url.searchParams.set('q', term);
    // Products only. Collections and pages come from the fragment itself, via
    // snippets/aaiko-search-links, so asking Shopify for them here would only
    // buy a second opinion this build then has to reconcile. 10 is the API
    // ceiling for resources[limit]; the 15 that stood here was never honoured.
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    // Sold-out products keep their relevance rank rather than being sunk under
    // every in-stock one; a searched-for style that happens to be out of stock
    // has to be findable. See sections/aaiko-search.liquid for the full note.
    url.searchParams.set('resources[options][unavailable_products]', 'show');
    url.searchParams.set('section_id', this.dataset.suggestSection || 'aaiko-search-suggest');
    try {
      const response = await fetch(url.toString(), { signal: this.controller.signal });
      if (!response.ok) return;
      this.replaceResults(await response.text());
    } catch (error) {
      if (error.name !== 'AbortError') throw error;
    }
  }

  /* Collections and pages arrive from a fragment rendered by Shopify's Search
     Suggestions endpoint, which has no template, no page and no collection, so
     snippets/aaiko-search-links cannot resolve the audience there and marks the
     girls rows instead of dropping them. The panel renders ON the page, so it
     is the one that knows, and it does the dropping here.

     AAIKO, 31/08/2026: "bij women een aantal girls voorbeelden komen in
     suggesties, en dat willen we niet." A term like "tops" matches Tops and
     Tops girls equally well, so without this the panel would have said it
     again, in a new place.

     The snippet offers a few extra rows precisely so this can cut and still
     fill the list; whatever survives is trimmed back to four. */
  applyAudience(root) {
    if (this.dataset.audience !== 'girls') {
      root.querySelectorAll('li[data-aaiko-girls]').forEach((li) => li.remove());
    }
    root.querySelectorAll('.aaiko-slinks__list').forEach((list) => {
      Array.from(list.children)
        .slice(4)
        .forEach((li) => li.remove());
      if (!list.children.length) list.closest('.aaiko-slinks')?.remove();
    });
  }

  /* The fragment arrives over the network and would otherwise pop in. The
     incoming region is inserted transparent and faded up on the next frame, so
     a typed query reads as a crossfade rather than a flash. Resting opacity is
     1, so nothing here changes what the harness measures. */
  replaceResults(markup) {
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const next = parsed.querySelector('[data-aaiko-search-results]');
    if (!next) return;
    this.applyAudience(next);
    next.setAttribute('data-swapping', '');
    this.results.replaceWith(next);
    this.results = next;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => next.removeAttribute('data-swapping'));
    });
  }
}

if (!customElements.get('aaiko-search-panel')) {
  customElements.define('aaiko-search-panel', AaikoSearchPanel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
